module.exports = __webpack_public_path__ + "static/media/Haze.84170559.jpg";